import { trackEvent } from './segment';

export const trackHeroCTAClick = () => {
  trackEvent({
    event: 'hero_jump_to_pricing_clicked'
  });
};

export const trackDesignPackagesCTAClick = () => {
  trackEvent({
    event: 'start_project_clicked'
  });
};

export const trackUnlimitedRevCTAClick = () => {
  trackEvent({
    event: 'unlimited_rev_jump_to_pricing_clicked'
  });
};

export const trackBottomCTAClick = () => {
  trackEvent({
    event: 'bottom_cta_jump_to_pricing_clicked'
  });
};

export const trackPackageSelectCTAClick = ({packageSku, packagePrice}) => {
  trackEvent({
    event: 'package_selection',
    properties: {
      package_type: packageSku,
      package_price: packagePrice
    }
  });
};

export const trackComparePackagesClick = () => {
  trackEvent({
    event: 'compare_packages_clicked'
  });
};

export const trackStartShowroomClick = () => {
  trackEvent({
    event: 'start_express_flow_clicked'
  });
};
